import DashboardSinglePageEmptyState from "./DashboardSinglePageEmptyState";

export default DashboardSinglePageEmptyState;
